import { HttpClient, HttpParams } from '@angular/common/http';
import RequestCache from '../utils/RequestCache';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

import { DashboardDataModel, EventConversionsModel } from '../model';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  public readonly dashboardData: RequestCache<DashboardDataModel>;

  constructor(private readonly http: HttpClient) {}

  public getContractsDashboardData(advisorId?: string): Observable<DashboardDataModel> {
    const params: Record<string, string> = {};

    if (advisorId) {
      params['advisor_id'] = advisorId;
    }

    return this.http.get<DashboardDataModel>(`${environment.apiEndpoint}/b2b/dashboard`, { params });
  }

  /** FIN-7177: contracts created within `days` after a bank event of the same client. */
  public getEventConversions(days: number = 90, advisorId?: string): Observable<EventConversionsModel> {
    const params: Record<string, string> = { days: String(days) };
    if (advisorId) {
      params['advisor_id'] = advisorId;
    }
    return this.http.get<EventConversionsModel>(`${environment.apiEndpoint}/b2b/dashboard/event-conversions`, {
      params,
    });
  }
}
